export const HIGHLIGHTED_FILTER_PARAM = "highlighted";
